// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"speakers_wrapper__huz9n","speaker":"speakers_speaker__sM6HY","title":"speakers_title__ee9Mb","SeeAllSpeakers":"speakers_SeeAllSpeakers__2OP6s"};